import util from '../config/util';
import store from '../store/'
import { api,apiKey } from './IsApi';
import list from './getData';
/**
 * 判断如何读取缓存
 */
const isNeadGetData = (module,version) => {
	var need = true;
	var cstate = store.state.common;
	var key=apiKey[module];
	if(cstate.sysConfig && cstate.sysConfig.value && cstate.sysConfig.value.cache_model) {
		var currentModelCacheConfig = null;
		var cacheConfig = cstate.sysConfig.value.cache_model

		cacheConfig.forEach(function(item, index, input) {
			if(item.k == key) {
				currentModelCacheConfig = item;
				return;	
				//need = true;
			}
		});
		if(currentModelCacheConfig) {
			let model = currentModelCacheConfig.m;

			//－1:完全不使用cache，
			// 01:不使用前段cache，使用服务器cache(需要验证版本和时间），
			// 11:使用前端cache和服务器cache(需要验证版本和时间），
			// 10:使用前端cache使用服务器cache（需要验证版本和时间），
			// 20:使用前端cache（如果前端cache存在就不和后台发生任何交互）
			// 22:使用前端cache和服务器cache（如果前端cache存在就不和后台发生任何交互，如果服务器cache存在，就不与数据库发生交互）；
			if(model == '20' || model == '22') {
				need = false;
			}
			// console.error('缓存版本:'+version)
			// console.error(currentModelCacheConfig.k)
			// console.error('API版本:'+currentModelCacheConfig.v)
			if(version>=currentModelCacheConfig.v){
				console.log('使用cache',module)
				need=false
			}
		}
	}

	return need;
};

const getThroughCache = async(model, resf, ...params) => {
	let v = 0

	let up = util.formatDate.format(new Date(), 'yyyy-MM-dd hh:mm:ss')

	let obj = store.state[model.using][model.name]; //.getStore(model);
	
	if(obj && obj.version) {
		v = obj.version.version;
		up = obj.version.last_up_time;
	}
	var nead = isNeadGetData(model.name,v);
	if(nead || !obj || !obj.value) {
		console.log('nead get data from api : ' + model.name);
		let p = [...params[0]];
		//console.log(p);
		obj = await resf(...p);
		//console.log(obj);
	}
	else{
		console.log('get data from local cache : ' + model.name);
		obj.response = {
			code:0,					//-1 出现错误，0:请直接使用客户端缓存， 1:正常返回数据
			error_code:"0000",		//错误代码，0000：没有错误，其他代表不同的含义
			message:"正确"			//返回提示信息
		};
	}

	if(obj&&obj.response&&obj.response.code==-10){
		obj.response.code=1;
	}	

	return obj;
};

var api_methods = {};
for(var item in list) {
	if(api[item]) {
		api_methods[item] = (function(key, fn) {
			return function(...params) {
				return getThroughCache(key, fn, params);
			}
		})(api[item], list[item])
	} else {
		api_methods[item] = list[item]
	}
}

export {
	api_methods
}
